module.exports = __webpack_public_path__ + "img/home.46e556d0.jpg";